import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useCourtAPIDetails = () => {
  const [courtList, setCourtList] = useState([]); // Initialize as an empty array

  const fetchCourtsList = async () => {
    const token = Cookies.get("auth_token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/court/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "Success") {
        setCourtList(response.data.data);
        return response.data.data; // Return fresh data instead of stale state
      }
    } catch (error) {
      console.error("Error fetching courts:", error);
      return []; // Return an empty array on failure
    }
  };

  return {
    courtList,
    fetchCourtsList,
  };
};

export default useCourtAPIDetails;
